export default __webpack_public_path__ + "static/media/JHU_IncidentCases_State.66385d48.csv";